(function () {
    'use strict';

    angular
        .module('app')
        .factory('app.paymentService', ['$q', '$http', 'payments', 'ui', paymentService]);

    /**
     * Payment Service responsible for communicating with our payment processor, Vantiv.
     * @param {any} $q
     * @param {any} $http
     * @param {any} util
     * @param {any} config
     */
    function paymentService($q, $http, payments, ui) {

        return {
            tokenizePaymentMethod: tokenizePaymentMethod
        };

        /**
         * Passes user payment information, such as credit card, to EProtect. This ensures
         * Vantiv manages and secures user payment information.
         * @param {any} formFields
         * @returns {object} An object representing the eProtect / payPage registration, which includes the unique ID for the
         * payment method
         */
        function tokenizePaymentMethod(accountNumber, cvv) {

            var settings = {
                payPageId: environment.payPageId,
                reportGroup: environment.reportGroup,
                eProtectUrl: environment.eProtectUrl
            };

            var id = generateOrderId();

            var litleRequest = {
                "paypageId": settings.payPageId,
                "reportGroup": settings.reportGroup,
                "orderId": id,
                "id": id,
                "url": settings.eProtectUrl
            };

            // Needed to make the Vantiv js library happy
            var formFields = {
                "accountNum": document.getElementById('accountNumber'),
                "cvv2": document.getElementById('securityCode'),
                "paypageRegistrationId": document.getElementById('response$paypageRegistrationId'),
                "bin": document.getElementById('response$bin')
            };

            formFields.accountNum.value = accountNumber;
            formFields.cvv2.value = cvv;
            var litleResponse = $q.defer();
            new LitlePayPage().sendToLitle(litleRequest,
                formFields,
                function success(response) {
                    litleResponse.resolve(response);
                },
                function error(response) {
                    var processor = new payments.litlePaypageErrorProcessor();
                    if (response && response.response) {
                        ui.error(processor.generateErrorMessage(response.response));
                    } else {
                        ui.error(processor.generateErrorMessage(null));
                    }
                    
                    ui.unblock();
                    litleResponse.reject();
                },
                function timeout() {
                    ui.error("We are experiencing technical difficulties. Please try again later.");
                    ui.unblock()
                    litleResponse.reject();
                },
                15000);

            return litleResponse.promise.then(function (result) {
                return result;
            });
        }

        /**
         * @returns A unique 25 char string to be used for the vantiv id/orderId
         */
        function generateOrderId() {
            var d = new Date().getTime();
            var id = 'xxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g,
                function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (r).toString(16);
                });
            return id;
        };
    }
})
    ();